import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { endAt, onValue, orderByKey, query, ref, startAt } from "firebase/database";
import { FaFilter, FaSearch } from "react-icons/fa";
import { database } from "../firebaseConfig";
import { setEndDate, setFilters, setReports, setStartDate } from "../redux/slices/promitheies";
import { setLoading } from "../redux/slices/ui";
import PageHeader from "../components/ui/PageHeader";
import DateRangeForm from "../components/ui/DateRangeForm";
import NoData from "../components/ui/NoData";
import AddPromitheia from "../components/promitheies/AddPromitheia";
import List from "../components/promitheies/List";

const Promitheies = () => {
  const dispatch = useDispatch();
  const reports = useSelector((state) => state.ekkathariseis.list);
  const { startDate, endDate, filters } = useSelector((state) => state.ekkathariseis);

  const fetchReports = () => {
    if (!startDate || !endDate) return;
    dispatch(setLoading(true));
    const reportsQuery = query(ref(database, "ekkathariseis"), orderByKey(), startAt(startDate), endAt(endDate));
    onValue(reportsQuery, (snapshot) => {
      const data = snapshot.val();
      const list = data ? Object.entries(data).map(([date, report]) => ({ date, ...report })) : [];
      dispatch(setFilters(list.length === 0));
      dispatch(setReports(list));
      dispatch(setLoading(false));
    });
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchReports();
  };

  // Auto-load with the default date range when the screen opens.
  React.useEffect(() => {
    fetchReports();
  }, []);

  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      <PageHeader title="Εκκαθαρίσεις">
        {reports.length > 0 && !filters ? (
          <FaFilter className="cursor-pointer text-brand-600" onClick={() => dispatch(setFilters(true))} size={22} />
        ) : (
          <FaSearch className="cursor-pointer text-brand-600" onClick={handleSearch} size={22} />
        )}
      </PageHeader>

      <div className="flex-1 overflow-y-auto px-4 pb-24">
        {filters && (
          <DateRangeForm
            startDate={startDate}
            endDate={endDate}
            onStart={(v) => dispatch(setStartDate(v))}
            onEnd={(v) => dispatch(setEndDate(v))}
            onSubmit={handleSearch}
          />
        )}
        {reports.length === 0 ? <NoData /> : <List />}
      </div>

      <AddPromitheia />
    </div>
  );
};

export default Promitheies;
